<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    flattenedUsers: (flattenedUsers$ | async) ?? []
  }"
  >
</ng-container>

<ng-template #template let-flattenedUsers="flattenedUsers">
  @if (flattenedUsers) {
    @if (flattenedUsers.length) {
      <mat-toolbar>
        <span>{{ "Assigned Users" }}</span>
      </mat-toolbar>
    }
    <vp-users-list
      [users]="flattenedUsers"
      [columnsToDisplay]="displayedColumns"
      [isRouterLinkEnabled]="false"
    ></vp-users-list>
  }
</ng-template>
